// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"283":"8d02746d","315":"1e5b6f2f","923":"7dd16d39"}[chunkId] + ".chunk.js";
};